import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

class RenderName extends Component {
  render() {

    if(!this.props.args.cellData) return '-';
    return(
      <Grid 
        justify="center"
        alignItems="center"
        wrap="nowrap"
        container
        spacing={16}>
        <Grid
          item
          xs={2}
          sm={2}
          className="tc">
          {this.props.args.cellData.PlaceRank}
        </Grid>
        <Grid
          item
          sm={3}
          xs={3}
          className="pl0-override image-hack">
          <img 
            className="avatar"
            alt={'avi'} 
            src={this.props.args.cellData.ImageUrl} 
          />
        </Grid>
        <Grid 
          item
          xs={9}
          sm={9}
          onClick={this.props.openModal.bind(this, this.props.args.rowData)}
          className="tl overflow-hack pointer t-blue pl0-override">
          {this.props.args.cellData.FullName}
        </Grid>
        {/*<Grid 
          item
          xs={'auto'}
          sm={2}
          className="dn db-ns border-workaround"> 
          {this.props.args.Nationality &&
            <img 
              alt={this.props.args.cellData.Nationality} 
              src={process.env.REACT_APP_API_URL + '/images/countries/' + this.props.args.cellData.Nationality.toLowerCase() + '.png'} 
            />
          }
        </Grid>*/}
      </Grid>
    )
  }
}

RenderName.propTypes = {
  openModal: PropTypes.func.isRequired,
  args: PropTypes.object.isRequired
}

export default RenderName;